module.exports = __webpack_public_path__ + "img/icon-red-bar.86908c50.png";